import { Action } from "@ngrx/store";
import {
  GlobalAppSettings,
  GlobalHeader,
  RecentCompanyEntry,
} from "../models/global-header.model";
import { Dictionary } from "../models/common_types";
import { CompanyPageMeta } from "../models/company-page-store.model";

export const SET_MENU_OPTION = "SET_MENU_OPTION";
export const SET_GLOBAL_SETTINGS = "SET_GLOBAL_SETTINGS";
export const SET_GLOBAL_APP_SETTINGS = "SET_GLOBAL_APP_SETTINGS";
export const SET_ADDIN_EXPORT_SETTINGS = "SET_ADDIN_EXPORT_SETTINGS";
export const SET_SSO_SETTINGS = "SET_SSO_SETTINGS";
export const SET_NOTIFICATION_SETTINGS = "SET_NOTIFICATION_SETTINGS";
export const SET_RECENT_COMPANIES = "SET_RECENT_COMPANIES";
export const UPDATE_RECENT_COMPANIES = "UPDATE_RECENT_COMPANIES";

export class SetMenuOption implements Action {
  readonly type = SET_MENU_OPTION;

  constructor(public payload: GlobalHeader[]) {}
}

export class SetGlobalSettings implements Action {
  readonly type = SET_GLOBAL_SETTINGS;

  constructor(public payload: GlobalHeader | {}) {}
}

export class SetGlobalAppSettings implements Action {
  readonly type = SET_GLOBAL_APP_SETTINGS;
  constructor(public payload: GlobalAppSettings | {}) {}
}

export class SetAddinExportSettings implements Action {
  readonly type = SET_ADDIN_EXPORT_SETTINGS;

  constructor(public payload: GlobalHeader | {}) {}
}
export class SetSSOSettings implements Action {
  readonly type = SET_SSO_SETTINGS;

  constructor(public payload: GlobalHeader | {}) {}
}
export class SetNotificationSettings implements Action {
  readonly type = SET_NOTIFICATION_SETTINGS;

  constructor(public payload: Dictionary<string | boolean>) {}
}

export class SetRecentCompanies implements Action {
  readonly type = SET_RECENT_COMPANIES;
  constructor(public payload: Array<RecentCompanyEntry>) {}
}

export class UpdateRecentCompanies implements Action {
  readonly type = UPDATE_RECENT_COMPANIES;
  constructor(public payload: CompanyPageMeta) {}
}
export type Actions =
  | SetMenuOption
  | SetGlobalSettings
  | SetGlobalAppSettings
  | SetAddinExportSettings
  | SetSSOSettings
  | SetRecentCompanies
  | UpdateRecentCompanies
  | SetNotificationSettings;
